import { tns } from "../../../../legacy/node_modules/tiny-slider/src/tiny-slider";

require('./../fb_sdk.js');

Vue.component('contact-form', require('./../components/property_ad/invitation-form/index.vue').default);
Vue.component('mobile-invitation-form', require('./../components/property_ad/invitation-form/mobile-invitation-form.vue').default);
Vue.component('static-action', require('./../components/property_ad/invitation-form/static-action.vue').default);
Vue.component('ad_desc_collapse', require('./../components/property_ad/detail/ad_desc_collapse.vue').default);
Vue.component('ad-complaint', require('./../components/ad/ad-complaint/ad-complaint.vue').default);
Vue.component('phone-block', require('./../components/property_ad/detail/phone-block.vue').default);
Vue.component('phone-block-modal', require('./../components/property_ad/detail/phone-block-modal.vue').default);
Vue.component('verify-mobile-modal', require('./../components/modals/verify-mobile/verify-mobile.vue').default);
Vue.component('favorite-button', require('./../components/ad/favorite-button/favorite-button.vue').default);
Vue.component('ad-map', require('./../components/ad/ad-map/ad-map.vue').default);
Vue.component('host-details', require('./../components/ad/host/details.vue').default);
Vue.component('roommate-modal-form', require('./../components/roommate_ad/modal-form/roommate-modal-form.vue').default);
Vue.component('user-form', require('./../components/roommate_ad/modal-form/user-form.vue').default);
Vue.component('roommate-form', require('./../components/roommate_ad/modal-form/roommate-form.vue').default);
Vue.component('ad-share-modal', require('./../components/ad/ad-share/ad-share-modal.vue').default);
Vue.component('booking-index', require('./../components/property_ad/detail/booking_index.vue').default);
Vue.component('booking-modal', require('./../components/property_ad/detail/booking_modal.vue').default);
Vue.component('need-credits-modal', require('./../components/credits/need-credits-modal.vue').default);

!function () {
	"use strict";

	var Property = function () {
		this.number_photos = 0;
	}

	Property.prototype.events = function () {
		document.getElementById('lnk_about_owner')?.addEventListener('click', function () {
			document.getElementById('nav_owner').click();
		});

		$('.tb_places tfoot .lnk_see_more').click(function () {
			var table = $(this).parents('.tb_places');

			if ($(this).data('op') == 1) {
				table.find('tr.hidden').addClass('unhidden').removeClass('hidden');
				$(this).data('op', 0).html('- Ver Menos');
			} else {
				table.find('tr.unhidden').addClass('hidden').removeClass('unhidden');
				$(this).data('op', 1).html('+ Ver Mais');
			}

			return false;
		});
	}

	Property.prototype.initCarousel = function () {
		if (this.number_photos === 0)
			return false;

		let center = false;
		let items = 3;
		let loop = false;
		let autoWidth = true;

		if (window.innerWidth < 1170) {
			items = 2;
		}
		if (window.innerWidth < 768) {
			items = 1;
			center = true;
		}

		if (this.number_photos < items)
			items = this.number_photos;
		else
			loop = true;

		if (this.number_photos === 1) {
			autoWidth = false;
			center = true;
		}

		let carousel = tns({
			container: '.carousel',
			autoplay: false,
			center: center,
			rewind: false,
			items: items,
			nav: false,
			autoWidth: autoWidth,
			dots: false,
			loop: loop,
			mouseDrag: true,
			gutter: 2,
			controlsText: [
				'<i class="fa fa-4x fa-angle-left"></i>',
				'<i class="fa fa-4x fa-angle-right"></i>'
			],
			onInit: function () {
				let list = document.querySelectorAll('.carousel div.slide_img img');
				
				for (let i = 0, all = list.length; i < all; i++){
					list[i].classList.add('loaded');
				}
			}
		});

		carousel.events.on('indexChanged', function () {
			window.dataLayer.push({
				event: 'carousel_click',
				event_category: 'property_ad_page',
				event_label: 'carousel_click',
			});
		});

		this.initGallery();
	}

	Property.prototype.initAffixNav = function () {
		var ad_content = $('#property_content');
		var nav_bar = $('#subnav_section');
		
		nav_bar.affix({
			offset: {
				top: 520,
			}
		}).on('affix.bs.affix', function () {
			ad_content.css({
				'padding-top': nav_bar.outerHeight()
			})
		}).on('affixed-top.bs.affix', function (e) {
			ad_content.removeAttr('style');
		});

		var msg_block = $('#msg_block');
        var w = msg_block.parent().width();
        let bottom = 1100;

		msg_block.affix({
			offset: {
				top: function () { return 545; },
				bottom: function () { return bottom; }
			}
		}).on('affix.bs.affix', function () {
			msg_block.css({
				width: w
			});
		}).on('affixed-top.bs.affix', function () {
			msg_block.removeAttr('style');
		});

		if ( msg_block.hasClass('affix') ) {
			msg_block.css({
				width: w
			});
		}
	}

	Property.prototype.initClickListener = function () {
		document.getElementById('btn_ad_share').addEventListener('click', function(e) {
			EventBus.$emit('open-modal', 'ad-share-modal');
			e.preventDefault();
		});

		document.querySelectorAll('#similar_ads .property-card').forEach(function(element, index) {
			element.addEventListener('click', function() {
				window.dataLayer.push({
					event: 'open_similar_ad',
					event_category: 'property_ad_page',
					event_label: 'similar_ad_' + index,
				});
			});
		});
	}

	Property.prototype.initScrollspy = function () {
		var top_nav = $('#topnav');
		var top_nav_height = top_nav.outerHeight();

		var lastId,
		p_nav = $("#subnav_section"),
		nav_height = p_nav.outerHeight() + 15,
		menuItems = p_nav.find("a"),
		scrollItems = menuItems.map(function() {
			var item = $($(this).attr("href"));
			if (item.length)
				return item;
		});

		// Bind event click on menu items
		menuItems.click(function(e){
			var href = $(this).attr("href"),
				offsetTop = href === "#" ? 0 : $(href).offset().top - nav_height - top_nav_height + 1;

			$('html, body').stop().animate({
				scrollTop: offsetTop
			}, 300);

			window.dataLayer.push({
				event: 'nav_click',
				event_category: 'property_ad_page',
				event_label: 'nav_click',
			});

			e.preventDefault();
		});

		$(window).scroll(function() {
			var fromTop = $(this).scrollTop() + nav_height + top_nav_height;

			// Get id of current scroll item
			var cur = scrollItems.map(function() {
				if ($(this).offset().top < fromTop)
					return this;
			});

			// Get the id of the current element
			cur = cur[cur.length - 1];
			var id = cur && cur.length ? cur[0].id : "";

			if (lastId !== id) {
				lastId = id;
				// Set/remove active class
				menuItems
					.parent().removeClass("active")
					.end().filter("[href='#" + id + "']").parent().addClass("active");
			}
		});
	}

	Property.prototype.initGallery = function () {
		Promise.all([
			require('../../../../legacy/node_modules/lightgallery.js'),
			require('../../../../legacy/node_modules/lg-thumbnail.js')
		]).then (function () {
			lightGallery(document.getElementById('lightgallery'), {
				selectWithin: '.carousel',
				selector: '.tns-item[id]:not([id=""]) img',
				download: false,
				thumbnail: true,
				exThumbImage: 'data-thumb',
				toggleThumb: false,
				speed: 400,
			});
		})
	}

	Property.prototype.openGallery = function (index, element) {
		const el = document.getElementById('lightgallery');
		const parent = element.closest('.tns-item');
		
		if (parent !== null && typeof parent !== typeof undefined && !parent.hasAttribute('id')) {
			window.lgData[el.getAttribute('lg-uid')].build(index);
		}
	}

	Property.prototype.init = function () {
		this.events();
		this.initClickListener();
		this.initScrollspy();
		this.initAffixNav();
		this.initCarousel();
	}

	window.Property = new Property, window.Property.Constructor = Property;
}();

window.onload = function () {
	setTimeout(function () {
		window.Property.init();
		$('[data-toggle="tooltip"]').tooltip({container: 'body'});
	}, 250);

	EventBus.$emit('close-beacon', 'beacon');
};
